<template>
    <div class="main">
        <div class="container">
            <a-row :gutter="40" style="border: 1px solid #e8e8e8;">
                <a-col :span="12">
                    <a-card title="任务信息" :bordered=false :loading="loading" :headStyle="{paddingLeft: '15px', color: '#1890ff'}">
                        <div class="content">
                            <p class="title">{{title}}<a-icon type="fire" style="color: red;padding-left: 6px;" v-if="urgent"/></p>
                            <p class="desc" style="word-break: break-all;" >任务描述<span class="desc-title">{{delHtmlTag(remark)}}</span></p>
                            <p class="desc">任务标引<span class="desc-title">{{tagtitle}}</span></p>
                            <a-divider></a-divider>
                            <p class="desc">开始时间<span class="desc-title">{{starttime}}</span></p>
                            <p class="desc">结束时间<span class="desc-title">{{endtime}}</span></p>
                            <p class="desc">发布时间<span class="desc-title">{{addtime}}</span></p>
                            <p class="desc">发布人员<span class="desc-title">{{adduser}}</span></p>
                            <p class="desc">紧急任务<span class="desc-title"><a-switch :checked="urgent" size="small"/></span></p>
                            <a-button type="primary" style="margin-bottom: 20px;" @click="goBackToList">
                                <a-icon type="left" />返回
                            </a-button>
                        </div>
                    </a-card>
                </a-col>
                <a-col :span="12">
                    <a-card title="任务跟踪" :bordered=false :loading="loading" :headStyle="{paddingLeft: '15px', color: '#1890ff'}">
                        <div class="content">
                            选择执行人：
                            <a-select :defaultValue="currentPerson" @change="changeUser" style="min-width: 200px;">
                                <a-icon slot="suffixIcon" type="smile" />
                                <a-select-option :value="item.deptname + item.reporter" v-for="(item, index) in executor" :key="index">{{item.deptname}}-{{item.reporter}}</a-select-option>
                            </a-select>
                            <a-timeline style="margin-top: 26px;" v-if="currentPerson && isShowResults(classifiedExecutorsObject[currentPerson])">
                                <a-timeline-item v-for="(_item, _index) in classifiedExecutorsObject[currentPerson].results" :key="_index" :color="!_index && classifiedExecutorsObject[currentPerson].status != 5 ? 'red' : 'blue'" >
                                    <a-icon slot="dot" type="check-circle" style="fontSize: '16px'" v-if="!_index && classifiedExecutorsObject[currentPerson].status == 5"/>
                                    <a-icon slot="dot" type="clock-circle-o" style="fontSize: '16px'" v-if="!_index && classifiedExecutorsObject[currentPerson].status != 5"/>
                                    <p class="timeline-title" :class="[classifiedExecutorsObject[currentPerson].status == 5 && !_index ? 'color-done' : '']">{{_item.time}}</p>
                                    <p :class="[classifiedExecutorsObject[currentPerson].status == 5 && !_index ? 'color-done' : '']">{{delHtmlTag(_item.mark)}}</p>
                                </a-timeline-item>
                            </a-timeline>
                        </div>
                    </a-card>
                </a-col>
            </a-row>
        </div>
    </div>
</template>

<script>
    function Trim (str, is_global) {
        var result
        result = str.replace(/(^\s+)|(\s+$)/g, '')
        if (is_global.toLowerCase() === 'g') {
            result = result.replace(/\s/g, '')
        }
        return result
    }
    export default {
        name: "TaskDetail",
        data () {
            return {
                userInfo: '',
                title: '',
                tagtitle: '',
                remark: '',
                starttime: '',
                endtime: '',
                adduser: '',
                addtime: '',
                executor: [],
                urgent: false,
                currentPerson: '',
                classifiedExecutorsObject: {}, // 按部门+姓名组成得每个人任务信息
                loading: true
            }
        },
        methods: {
            isShowResults (currentObject) {
                return currentObject.hasOwnProperty('results')
            },
            delHtmlTag (str) {
                var delHtmlTag = str.replace(/<[^>]+>/g, '') // 去掉所有的html标记
                return Trim(delHtmlTag, 'g')
            },
            changeUser (value) {
                this.currentPerson = value
            },
            goBackToList () {
                // this.$router.push('/Main/Task/TaskList')
                this.$router.go(-1)
            }
        },
        created () {
            this.userInfo = JSON.parse(localStorage.getItem('siteinfo'))
        },
        mounted () {
            this.$http.post('api/assign/taskdetail', {id: this.$route.query.id})
                .then((res) => {
                    this.loading = false
                    if (res.data.state === 200) {
                        this.title = res.data.data.title
                        this.tagtitle = res.data.data.tagtitle
                        this.remark = res.data.data.remark
                        this.starttime = this.$commonFunction.transferTime(new Date(res.data.data.starttime))
                        this.endtime = this.$commonFunction.transferTime(new Date(res.data.data.endtime))
                        this.adduser = res.data.data.adduser
                        this.addtime = res.data.data.addtime
                        this.executor = res.data.data.executor
                        if (res.data.data.urgent == 1) {
                            this.urgent = true
                        } else {
                            this.urgent = false
                        }

                        this.currentPerson = res.data.data.executor[0].deptname + res.data.data.executor[0].reporter
                        for (var i in res.data.data.executor) {
                            this.classifiedExecutorsObject[res.data.data.executor[i].deptname + res.data.data.executor[i].reporter] = {}
                            this.classifiedExecutorsObject[res.data.data.executor[i].deptname + res.data.data.executor[i].reporter]["results"] = []
                            this.classifiedExecutorsObject[res.data.data.executor[i].deptname + res.data.data.executor[i].reporter]["status"] = ''
                            if (res.data.data.executor[i].records && res.data.data.executor[i].records.length) {
                                this.classifiedExecutorsObject[res.data.data.executor[i].deptname + res.data.data.executor[i].reporter].results = res.data.data.executor[i].records.reverse()
                            }
                            if (res.data.data.executor[i].status) {
                                this.classifiedExecutorsObject[res.data.data.executor[i].deptname + res.data.data.executor[i].reporter].status = res.data.data.executor[i].status
                            }
                        }
                    }
                })
                .catch(() => {
                })
        }
    }
</script>

<style scoped>
    .main {
        position: absolute;
        top: 42px;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: auto;
        background-color: #fff;
        overflow-x: hidden;
    }
    .container{
        padding: 20px 50px;
    }
    .container >>> .content{
        width: 96%;
        margin: 0 auto;
        margin-top: 20px;
    }
    .content .title{
        font-weight: bold;font-size: 16px;line-height: 40px;
    }
    .desc{
        line-height: 30px;
    }
    .desc .desc-title{
        padding-left: 10px;
        color: #000;
    }
    .color-done{
        color: #108ee9;
    }
</style>
